import {
  ProcessCellForExportParams,
  ProcessHeaderForExportParams,
} from '@ag-grid-community/core';

export const processContractTableHeaderCallback = (
  params: ProcessHeaderForExportParams,
) => {
  if (params.column.getColId() === 'recipient') {
    // For the 'recipient' column, we need to display three separate columns in the CSV export.
    // This is because the 'recipient' column contains nested information (first name, last name, email)
    // that we want to present as individual columns in the exported CSV.
    return `"Recipient first name","Recipient last name","Recipient email"`;
  }

  return `"${params.column.getColDef().headerName || ''}"`;
};

export const processContractTableCellCallback = (
  params: ProcessCellForExportParams,
) => {
  const rowData = params.node?.data;
  const colId = params.column.getColId();

  // Customize cell values during CSV export based on column ID.
  switch (colId) {
    case 'recipient':
      return `"${rowData.recipient?.givenName || ''}","${
        rowData.recipient?.familyName || ''
      }","${rowData.recipient?.email || ''}"`;

    case 'createdAt':
    case 'submissionDate':
    case 'latestSubmissionDate':
      return rowData[colId]
        ? `${new Date(Date.parse(rowData[colId])).toLocaleDateString()}`
        : '';

    default:
      return `"${params.value || ''}"`;
  }
};
